exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-4d45c1b8] .v-text-field .v-field--no-label input {\n  border: none !important;\n  --tw-shadow: none;\n  padding: 0;\n}\n[data-v-4d45c1b8] .v-input__prepend {\n  display: none !important;\n}\n[data-v-4d45c1b8] .v-date-input input {\n  cursor: text !important;\n}\n/* Fix the background color for the entire field container */\n[data-v-4d45c1b8] .v-field {\n  background-color: white !important;\n}\n[data-v-4d45c1b8] .v-field__overlay {\n  background-color: white !important;\n}\n", ""]);

// exports
